import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/Gov-body.webp";
import classroomImage from "../../Images/placement/training.f2035b574dbe1fb07010.webp";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Row } from "react-bootstrap";
import "../../Placement.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const InterviewTraining = () => {
    const pedagogyItems = [
        {
            icon: "🎓",
            title: "Access to Fresh Talent",
            description:
                "Campuses are a hub for young, skilled, and enthusiastic candidates. Employers can tap into this pool to find new talent with the latest academic knowledge and skills.",
        },
        {
            icon: "💰",
            title: "Reduce Recruitment Costs",
            description:
                "Campus recruitment is often more affordable than traditional methods, minimizing the need for extensive advertising and multi-stage screening processes.",
        },
        {
            icon: "🏢",
            title: "Build Your Brand’s Reputation",
            description:
                "Interacting with students helps companies establish their brand as a preferred employer among future professionals, supporting long-term recruitment strategies.",
        },
        {
            icon: "🤝",
            title: "Partner with Academic Leaders",
            description:
                "Campus hiring fosters long-term partnerships with universities, creating opportunities for collaboration in research, innovation, and knowledge sharing.",
        },
        {
            icon: "🌍",
            title: "Enhance Diversity Hiring",
            description:
                "Recruiting from campuses enables access to diverse backgrounds, skills, and perspectives, strengthening a company’s diversity and inclusion initiatives.",
        },
    ];

    const careers = [
        "Data Scientist",
        "Research Scientist",
        "Environmental Scientist",
        "Biotechnologist",
        "Laboratory Technician",
        "Software Developer",
        "Chemical Analyst",
        "Forensic Scientist",
    ];

    const trainingModules = [
        {
            title: "Effective Communication Training",
            content:
                "Having a formal conversation with interviewers during an interview requires excellent communication skills. Interviewers expect candidates to demonstrate their verbal communication skills. ISBM Training and Placement Team provides candidates with practical tips and techniques for enhancing their skill sets in communication skills.",
        },
        {
            title: "Behavioural Interview Training",
            content:
                "This training primarily outlines building rapports with candidates to ensure they are comfortable sharing their personal information and skills during an interview.",
        },
        {
            title: "Planning and Organising Interview Training",
            content:
                "It helps candidates understand and recognise legal policies and issues related to hiring. It teaches how to become efficient and better organised to stop wasting valuable time. It helps candidates create better professional goals and develop better plans to achieve those goals.",
        },
        {
            title: "Coding Interview Preparation Courses",
            content:
                "ISBM Training and Placement Team provides premium lectures, theory, practice tests and assessment tests of subjects like computer science, programming language, data structures, algorithms, reasoning and aptitude.",
        },
        {
            title: "Advanced Interviewing Techniques",
            content:
                "The advanced interviewing technique training focuses on handling competent and behavioural interviews. The training makes students adept at managing and handling workplace conflicts, analysing situations where they previously failed and guiding them with the best interview techniques for behavioural and traditional questions. It allows candidates to share skills, abilities and knowledge required by recruiters for a job role.",
        },
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 }
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    return (
        <>
            <title>ISBM University Interview Training | Campus Recruitment Support</title>
            <meta
                name="description"
                content="ISBM University offers extensive interview training to help you excel in campus recruitment. Gain practical tips & mock interview experience. Enroll now."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>Campus Recruitment & Interview Training</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Campus Recruitment
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Campus recruitment</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                Campus recruitment, also known as campus placement or college
                                placement, is when businesses visit educational institutions
                                like colleges and universities to recruit students for internships
                                or full-time positions.
                            </p>
                            <p className="text-muted">
                                A study by shows that nearly 70% of companies are hiring new
                                college graduates this year, illustrating the significance of
                                campus recruitment. This type of recruitment is mutually beneficial
                                for both students and companies. Students can secure employment before
                                graduation, often in their field of study, at the same time, companies
                                can access a pool of young, talented individuals eager to start their
                                careers.
                            </p>
                            <p className="text-muted">
                                On-campus recruitment is vital for companies to tap into a vibrant,
                                innovative pool of potential employees with the latest knowledge and
                                trends in their respective fields. This recruitment method is not only
                                cost-effective, allowing companies to engage with multiple promising
                                candidates in a single setting, but it also fosters a strong connection
                                between the academic and corporate worlds.
                            </p>
                            <p className="text-muted">Also, campus recruitment enhances diversity in the
                                workplace, as campuses are melting pots of talent from various backgrounds,
                                offering a wide variety of skills and perspectives. This diversity can
                                lead to a more dynamic, innovative, and inclusive work environment.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image mt-5">
                                <img src={classroomImage} alt="Campus recruitment and interview training session" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="container-xxl ptb-50">
                <h2 className="text-center modern-title section-title text-blue mb-5">
                    Main benefits of campus recruitment
                </h2>
                <div className="row m-0">
                    {pedagogyItems.map((item, index) => (
                        <div className="col-md-6 col-lg-4 mb-4" key={index}>
                            <div className="d-flex h-100 border-end border-sm-0 pe-3">
                                <div className="me-3 fs-1 text-secondary">{item.icon}</div>
                                <div>
                                    <h6 className="fw-bold mb-2 text-dark">{item.title}</h6>
                                    <p className="text-muted small mb-0">{item.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Vision */}
            <section className="container py-5">
                <div className="coList row mx-0 mt-30">
                    {/* Left Column */}
                    <div className="col-lg-5 col-12">
                        <div className="coCol1">
                            <figure>
                                <h2 className="black_title">INTERVIEW TRAINING</h2>
                            </figure>
                            <p>
                                Interviewing is an essential aspect of the hiring process and it is vital
                                to make a positive impression during a job interview. Having the desired
                                skills and abilities for an interview can increase your chances of getting
                                hired for the desirable job. If you appear for an interview, getting training
                                before an interview might prove beneficial.
                            </p>
                            <p>
                                Training and Placement Team organizes the Mock Interviews at department level
                                and also from the competent institutions to train the graduates about the dynamics
                                of Job interviews and the behavioural,soft and HR skills required during the Job interview.
                            </p>
                            <p>
                                ypes of Interview Training Provided by ISBM Training and Placement Team for the Graduates
                            </p>
                        </div>
                    </div>

                    {/* Right Column: Careers */}
                    <div className="col-lg-7 col-12">
                        <h2 className="text-center modern-title section-title text-blue mb-5">
                            Interview Training Modules
                        </h2>

                        <Slider {...settings}>
                            {trainingModules.map((module, index) => (
                                <div key={index} className="d-flex">
                                    <div className="coListLi border rounded-4 shadow h-100 p-3 w-100 d-flex flex-column justify-content-between">
                                        <h5 className="fw-bold mb-2">
                                            <i className="fa-solid fa-trophy me-2"></i>
                                            {module.title}
                                        </h5>
                                        <p className="mb-0">{module.content}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default InterviewTraining;
